/*
@todo qui è da implementare ancora il popup per la prenotazione
$('.page-pubblicazione #malattia-popup .panel-prenota-articolo .btn-warning').on('click',function() {
    setCookie('pren_src','click-articolo-pubblicazione-popup-top', 1, '/', 'o');
});
*/
$(document).ready(function(){

    $('.page-pubblicazione .panel-prenota-btn').on('click', function() {
        setCookie('pren_src', 'click-articolo-pubblicazione-popup-bottom', 1, '/', 'o');
        g4_event("Click", {'event_category': "Articoli", 'value' : 'pubblicazione-popup-bottom'});
    });

    $('.page-pubblicazione .box-medico-name').on('click', function() {
        setCookie('pren_src', 'click-articolo-pubblicazione-medico-top', 1, '/', 'o');
        g4_event("Click", {'event_category': "Articoli", 'value' : 'pubblicazione-medico-top'});
    });

});
